import { useEffect, useState } from "react";

/** Returnerer verdien først når han har vore stabil i `ms` millisekund. */
export const useDebounce = (value, ms = 300) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return debounced;
};
